
<template>
<div id="contenedor">
<v-layout row wrap>
    <v-flex xs12 sm12 md12>
    <v-card class="table" elevation="2">
        <!-- header director de area -->
        <v-toolbar flat elevation="4" color="grey lighten-3" class="mb-5">
        <v-card class="icon">
            <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-application-brackets</v-icon
            >
        </v-card>
        <div
            class="usuario text-uppercase ml-5 font-weight-bold blue-grey--text text--darken-3"
        >
            PROCESOS POR COMPRAR
        </div>
        <v-spacer></v-spacer>
        <!-- Dialog para crear proceso -->
        </v-toolbar>
        <!-- pinta la tabla 1 -->
        <v-container fluid class="white black--text mt-10">
        <v-card class="my-2 px-2" elevation="5" width="100%">
            <v-col cols="12" class="ma-0">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Aplicación"
                class="text-field"
                single-line
                color="#111c3d"
            ></v-text-field>
            </v-col>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <v-col cols="12" class="ma-0">
            <v-data-table
                :headers="headers"
                :items="apps"
                :search="search"
                style="border: 2px solid #111c3d"
                class="elevation-3"
            >
                <template v-slot:no-data>
                <v-alert
                    :value="true"
                    color="#E57373"
                    icon="mdi-alert"
                    outlined
                    type="warning"
                    prominent
                    border="left"
                >
                    <strong>No</strong> se encontro su busqueda
                </v-alert>
                </template>
                <template v-slot:[`item.procesos`]="{ item }">
                <v-icon color="error" class="ml-5" @click="pdfProcesos(item)"
                    >mdi-file-pdf-box 
                </v-icon>
                </template>
            </v-data-table>
            </v-col>
        </v-card>
        </v-container>
        
        <v-dialog
                v-model="dialogPdf"
                persistent
                :overlay="false"
                width="90%"
            >
                <v-card>
                <v-card-title class="nav">
                    <span class="headline" style="color: white"
                    ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                    Proceso Compra Proveedor 1
                    </span>
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->

                <div
                    style="
                    width: 95%;
                    margin: 1rem 0rem 1rem 2rem;
                    border: solid 2px black;
                    "
                    
                >
                    <div style="border: solid 1px black;" class="pa-3"  >
                    <v-layout wrap >
                        <v-flex xs1 class="ml-2">
                        <span><strong>Fecha:</strong></span>
                        </v-flex>
                        <v-flex xs4>{{editedItem.fechaCompra}}</v-flex>
                        <v-flex xs1>
                        <span><strong>Solicitante:</strong></span>
                        </v-flex>
                        <v-flex xs4> {{editedItem.nombreArea}} </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Proveedor:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogPdf==true"> 
                            <div v-if="editedItem.proveedor==1">
                                {{editedItem.proveedor1.nombreEmpresa}} 
                            </div>
                            <div v-if="editedItem.proveedor==2">
                                {{editedItem.proveedor2.nombreEmpresa}} 
                            </div>
                            <div v-if="editedItem.proveedor==3">
                                {{editedItem.proveedor3.nombreEmpresa}} 
                            </div>
                            
                        </v-flex>
                        <v-flex xs1>
                        <span><strong>Nit:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogPdf==true">
                            <div v-if="editedItem.proveedor==1">
                                {{editedItem.proveedor1.nit}} 
                            </div>
                            <div v-if="editedItem.proveedor==2">
                                {{editedItem.proveedor2.nit}} 
                            </div>
                            <div v-if="editedItem.proveedor==3">
                                {{editedItem.proveedor3.nit}} 
                            </div>
                        
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs1 class="ml-2">
                        <span><strong>Asunto:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogPdf==true">{{editedItem.infoProceso[0].asunto}}</v-flex>
                        <v-flex xs1>
                        <span><strong>Télefono:</strong></span>
                        </v-flex>
                        <v-flex xs4 v-if="dialogPdf==true">
                            <div v-if="editedItem.proveedor==1">
                                {{editedItem.proveedor1.celular}} - {{editedItem.proveedor1.telefono}}
                            </div>
                            <div v-if="editedItem.proveedor==2">
                                {{editedItem.proveedor2.celular}} - {{editedItem.proveedor2.telefono}} 
                            </div>
                            <div v-if="editedItem.proveedor==3">
                                {{editedItem.proveedor3.celular}} - {{editedItem.proveedor3.telefono}} 
                            </div>
                        </v-flex>
                    </v-layout>
                    </div>

                    <v-layout wrap style="width: 100%;">
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> ITEM </strong></v-flex>
                    <v-flex xs4 style="border: solid 1px black;" class="displayCenter fondo"><strong> DESCRIPCION </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> CANT. </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.UNIT </strong></v-flex>
                    <v-flex xs2 style="border: solid 1px black;" class="displayCenter fondo"><strong> VR.TOTAL </strong></v-flex>
                    </v-layout>
                    <v-layout wrap v-for="(item, index) in editedItem.infoCompra" :key="index">
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.id}} </v-flex>
                        <v-flex v-if="item.id!=null" xs4 style="border: solid 1px black;"> {{item.concepto}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayCenter"> {{item.cantidad}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd"> {{item.subtotal| currency}} </v-flex>
                        <v-flex v-if="item.id!=null" xs2 style="border: solid 1px black;" class="displayEnd" > {{item.valor| currency}} </v-flex>
                        
                    
                    
                    </v-layout>
                    <v-layout wrap>
                    <v-flex xs8 style="border: solid 1px black;"> 
                        <span>
                            ARGUMENTO PARA LA COMPRA:
                        </span>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd" ><strong>SUBTOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> IVA</strong></label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex xs12 sm12 md12 style="border: solid 1px black;">
                            <label for="" class="displayEnd"><strong> TOTAL</strong></label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            
                            style="border: solid 1px black;"
                            v-if="dialogPdf==true"
                        >
                            <label for="" class="displayEnd" >{{editedItem.infoCompra.at(-1).subTotal| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogPdf==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.infoCompra.at(-1).iva| currency}}</label>
                        </v-flex>
                        </v-layout>
                        <v-layout wrap>
                        <v-flex
                            xs12
                            sm12
                            md12
                            v-if="dialogPdf==true"
                            style="border: solid 1px black;"
                        >
                            <label for="" class="displayEnd">{{editedItem.infoCompra.at(-1).total| currency}}</label>
                        </v-flex>
                        </v-layout>
                    </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart">
                                <span class="mr-4">Forma de pago:</span>
                                <span v-if="dialogPdf==true">
                                    <div v-if="editedItem.proveedor==1">
                                        {{editedItem.proveedor1.formaPago}}
                                    </div>
                                    <div v-if="editedItem.proveedor==2">
                                        {{editedItem.proveedor1.formaPago}} 
                                    </div>
                                    <div v-if="editedItem.proveedor==3">
                                        {{editedItem.proveedor1.formaPago}} 
                                    </div>
                                
                                </span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                            <span class="mr-4">Anticipo:</span>
                            <span></span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs4>
                            <v-flex xs12 style="border: solid 1px black;" class="displayStart"> 
                                <span class="mr-4">
                                    Tiempo de entrega:
                                </span>
                                <span>
                                    
                                </span>
                            </v-flex>
                        </v-flex>
                    
                    </v-layout>
                    <v-layout wrap class="mt-5 ml-2 pa-2" >
                    <v-flex xs5 sm5 md5>
                        <v-text-field
                        disabled
                        label="Mayra Londoño"
                        class="mr-4"
                        ></v-text-field>
                        <label for="">ELABORADO POR</label>
                        <br>
                            Creado:
                            <label for="">{{editedItem.fechaProveedores}}</label>
                    </v-flex>
                    <v-flex xs6 class="d-flex" v-for="(item, index) in editedItem.aprobacion" :key="index">
                        <v-layout wrap v-if="item.rol == 'DIRECTOR AREA'">
                        <v-flex xs12 sm12 md12>
                            <v-text-field disabled class="mr-4" v-model="item.firma"></v-text-field>
                            <label for="" >APROBACION DIRECTOR DE ÁREA</label>
                            <br>
                                Aprobado:
                                <label for="">{{item.fechaAprobacion}}</label>
                        </v-flex>
                        
                        </v-layout>
                    </v-flex>
                    <!-- {{editedItem.aprobacion}} -->
                    </v-layout>
                </div>

                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="2" color="#f7e506" @click="close"
                    >Cerrar</v-btn
                    >
                    
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
                <!-- <pre v-if="dialogPdf==true">{{editedItem.infoCompra.at(-1)}}</pre> -->
                </v-card>
            </v-dialog>
        <!-- alertas de las acciones que se hacen -->
        <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#601ae4"
        style="color: white"
        >
        {{ text }}
        <v-btn color="#601ae4" depressed @click="snackbar = false"
            >Cerrar</v-btn
        >
        </v-snackbar>
    </v-card>
    </v-flex>
</v-layout>

</div>
</template>

<script>
    import axios from "axios";
    import env from "../env";
    import swal from "sweetalert";
    export default {
        data() {
            return {
                show: false,
                snackbar: false,
                y: "top",
                x: null,
                mode: "",
                timeout: 6000,
                text: "",
                search: "",
                apps: [],
                apps1: [],
                rules: {
                    required: (value) => !!value || "Required.",
                    counter: (value) => value.length <= 20 || "Maximo 20 characteres",
                    email: (value) => {
                        const pattern =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || "Invalido e-mail.";
                    },
                },
                dialog: false,
                dialogPdf:false,
                loader: true,
                loading: false,
                envia: true,
                contadorTabla: 0,
                estadoTabla: false,
                headers: [
                    {
                        text: "ID",
                        value: "idProceso",
                        align: "center",
                        class: "column",
                    },
                    {
                        text: "Area",
                        value: "nombreArea",
                        align: "center",
                        class: "column",
                    },
                    {
                        text: "Procesos",
                        value: "procesos",
                        align: "center",
                        class: "column",
                    },
                    {
                        text: "Fecha Compra",
                        value: "fechaCompra",
                        align: "center",
                        class: "column",
                    },
                    
                ],
                defaultItem: {
                    id: "",
                    concepto: "",
                    cantidad: "",
                    expecificaciones: "",
                    observaciones: "",
                },
                editedIndex: -1,
                editedItem: {
                    id: "",
                    concepto: "",
                    cantidad: "",
                    expecificaciones: "",
                    observaciones: "",
                },
            };
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Crear Proceso" : "Editar Aplicacion";
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        mounted() {
            this.obtenerApps();
        },

        methods: {
            // Metodo para obtener las aplicaciones
            obtenerApps() {
                axios
                .get(
                    `${env.endpoint}user/comprasRealizadas`
                )
                .then((res) => (this.apps = res.data));
            },

            /**
                * Metodo para agregar fila de la tabla en la modal
                */
            editItem(item) {
                this.editedIndex = this.apps1.indexOf(item);
                // console.log("el valor de editar es:", item)
                this.editedItem = Object.assign({}, item);
                // console.log("el valor de  ", this.editedIndex)
                // console.log("el valor de editedItem", this.editedItem)
                this.dialog = true;
            },

            /**
                * Metodo para cerrar la modal
                */
            close() {
                this.dialog = false;
                this.dialogPdf = false;
                setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                }, 300);
            },

            cargartabla() {
                this.contadorTabla++;
                this.editedItem.id = this.contadorTabla;
                this.apps1.push(this.editedItem);
                this.estadoTabla = true;
                this.close();
            },
            pdfProcesos(item){
                this.editedIndex = this.apps1.indexOf(item);
                this.editedItem = Object.assign({}, item);
                console.log(this.editedItem);
                this.dialogPdf = true;
                
            },
        },
};
</script>
<style lang="scss" scoped>
    .fondo {
    background-color: rgb(207, 206, 206);
    }
    .displayCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-all;
    padding: 3px 0px 3px 0px;
    }
    .displayEnd {
    display: flex;
    justify-content: end;
    align-items: end;
    word-break: break-all;
    padding: 10px;
    }
    .displayStart {
    display: flex;
    justify-content: start;
    align-items: start;
    word-break: break-all;
    padding: 10px;
    }
    .colorMin {
    background-color: #4bddfd;
    }
    
    /* Estilos para scroll horizontal en tablas */
    .v-data-table >>> .v-data-table__wrapper {
        overflow-x: scroll !important;
        overflow-y: visible !important;
        max-width: 100%;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
        height: 12px !important;
        display: block !important;
        -webkit-appearance: none;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
        background: #e5e7eb !important;
        border-radius: 6px !important;
        margin: 0 10px;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
        background: #64748b !important;
        border-radius: 6px !important;
        border: 2px solid #e5e7eb;
    }
    
    .v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
        background: #475569 !important;
    }
    
    .v-data-table >>> .v-data-table__wrapper {
        scrollbar-width: thin;
        scrollbar-color: #64748b #e5e7eb;
    }
</style>
